import { render, staticRenderFns } from "./StepUp.vue?vue&type=template&id=4c593074&scoped=true"
import script from "./StepUp.vue?vue&type=script&lang=js"
export * from "./StepUp.vue?vue&type=script&lang=js"
import style0 from "./StepUp.vue?vue&type=style&index=0&id=4c593074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c593074",
  null
  
)

/* custom blocks */
import block0 from "./StepUp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports